<template>
  <b-list-group>
    <b-list-group-item
        class="d-flex align-items-left"
        v-for="(aCategory, i) in categories"
        style="margin-top: 25px; background-color:#222222; border-color:#222222; "
        >
          <b-icon
              v-if="aCategory.bicon"
              :icon="aCategory.bicon"
              scale="1.6"
              variant="light"
              style="margin-right:15px;"
          />
          <h4>
            {{ aCategory.text }}
          </h4>
  </b-list-group-item>
  </b-list-group>
</template>

<script>
export default {
  name: "Display_MyAppStore_CategorySide",
  components: {},
  props: {
    categories: {
      type: Array,
      default: () => []
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped></style>
